module.exports = __webpack_public_path__ + "img/9.ec1d275d.png";